import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
    title: {
        id: 'help-centre-virtual-agent.error-page.title',
        defaultMessage: "We're not sure what went wrong",
        description: 'Generic error message',
    },
    description: {
        id: 'help-centre-virtual-agent.error-page.description',
        defaultMessage: 'Try <link>reload chat</link>.',
        description: 'Error title',
    },
});
